module.exports = __webpack_public_path__ + "media/pdf/reciprocity_logo_membership_pass-6627033a.png";